import useGoogleMapsAutocompleteService from '~/src/hooks/google-maps/useGoogleMapsAutocompleteService'
import { Dispatch, SetStateAction, useCallback, useState } from 'react'
import { Constants } from '~/src/helpers/constants'
import { debounce } from '@mui/material'

interface ReturnsType {
  isLoading: boolean,
  options: readonly google.maps.places.AutocompletePrediction[],
  setOptions: Dispatch<SetStateAction<readonly google.maps.places.AutocompletePrediction[]>>,
  value: string | google.maps.places.AutocompletePrediction | undefined,
  setValue: Dispatch<SetStateAction<string | google.maps.places.AutocompletePrediction | undefined>>,
  fetch(input: string): Promise<void>,
}

const useGetPlacePredictions = (): ReturnsType => {
  const [ isLoading, setIsLoading ] = useState<boolean>(false)
  const [ options, setOptions ] = useState<readonly google.maps.places.AutocompletePrediction[]>([])
  const [ value, setValue ] = useState<string | google.maps.places.AutocompletePrediction | undefined>('')
  const autocompleteService = useGoogleMapsAutocompleteService()

  const fetch = useCallback(
    debounce(async (input: string): Promise<void> => {
      if (!autocompleteService) {
        return
      }

      setIsLoading(true)

      try {
        // @ts-ignore
        await autocompleteService.getPlacePredictions({ input }, (results?: readonly google.maps.places.AutocompletePrediction[]) => {
          let newOptions: readonly google.maps.places.AutocompletePrediction[] = []

          if (value instanceof String) {
            return
          }

          if (value) {
            newOptions = [ value as google.maps.places.AutocompletePrediction ]
          }

          if (results) {
            newOptions = [ ...newOptions, ...results ]
          }

          setOptions(newOptions)
        })
      } finally {
        setIsLoading(false)
      }
    }, Constants.DEBOUNCE_TIME * 2),
    [ autocompleteService, value ]
  )

  return {
    isLoading,
    fetch,
    options,
    setOptions,
    value,
    setValue
  }
}

export default useGetPlacePredictions
